import { RelationCardinality, RelationCardinalityType } from "../contracts/base/relation-cardinality";

export class RelationCardinalityMapper {
    // eslint-disable-next-line @typescript-eslint/no-redundant-type-constituents
    static mapToEnumValue(value: RelationCardinalityType | string): RelationCardinality {
        if (value === "ManyToMany") {
            return RelationCardinality.ManyToMany;
        } else if (value === "OneToMany") {
            return RelationCardinality.OneToMany;
        } else if (value === "OneToOne") {
            return RelationCardinality.OneToOne;
        } else {
            throw Error(`Can't map '${value}' to enum value.`);
        }
    }

    static mapToType(value: RelationCardinality | string): RelationCardinalityType {
        if (value === RelationCardinality.ManyToMany || value === RelationCardinality[RelationCardinality.ManyToMany]) {
            return "ManyToMany";
        } else if (
            value === RelationCardinality.OneToMany ||
            value === RelationCardinality[RelationCardinality.OneToMany]
        ) {
            return "OneToMany";
        } else if (
            value === RelationCardinality.OneToOne ||
            value === RelationCardinality[RelationCardinality.OneToOne]
        ) {
            return "OneToOne";
        } else {
            throw Error(`Can't map '${value}' to type.`);
        }
    }
}
